package com.futurions.portfolio.animations

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent

val RotateSphere3D = Keyframes {
    0.percent {
        Modifier.styleModifier {
            property("transform", "rotateY(0deg) rotateX(0deg)")
        }
    }
    50.percent {
        Modifier.styleModifier {
            property("transform", "rotateY(180deg) rotateX(10deg)")
        }
    }
    100.percent {
        Modifier.styleModifier {
            property("transform", "rotateY(360deg) rotateX(0deg)")
        }
    }
}


val CodeSphere3DStyle = CssStyle {
    base {
        Modifier
            .size(280.px)
            .borderRadius(50.percent)
            .display(DisplayStyle.Flex)
            .justifyContent(JustifyContent.Center)
            .alignItems(AlignItems.Center)
            .backgroundColor(Color.rgba(0, 0, 0, 0.2f))
            .boxShadow(
                offsetX = 0.px, 0.px, 40.px, color = Color.rgba(0, 255, 255, 0.3f))
            .overflow(Overflow.Hidden)
            .transformStyle(TransformStyle.Preserve3d)
            .animation(
                RotateSphere3D.toAnimation(
                    duration = 10.s,
                    timingFunction = AnimationTimingFunction.Linear,
                    iterationCount = AnimationIterationCount.Infinite
                )
            )
            .styleModifier {
                property("perspective", "900px")
            }
    }

    hover {
        Modifier
            .transform {
                rotateX(20.deg)
                // rotateY may not exist depending on your compose-web; if it does:
                rotateY(20.deg)
                translateZ(20.px)
                scale(1.05)
            }
            .boxShadow(offsetX = 0.px, 0.px,  60.px, color =  Color.rgba(0, 255, 255, 0.7f))
    }
}
